import { HTTPClient } from '@abaco/web-common/src/HTTP';
import { Indicator } from "../models/SouthernWatersModels";

export default class SouthWatersApi {
    private http: HTTPClient;

    constructor(http: HTTPClient) {
        this.http = http;
    }

    public async getAllIndicators(lotId: string): Promise<Indicator[]>
    {
        const res = await this.http.get(`/sw/api/v1/indicators/${lotId}`)

        return res.data
    }
}
